module.exports = __webpack_public_path__ + "img/jindu.6de8ebea.png";